/**
 * SGKC036A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Sgkc036aReqReImportTargetSearchInfoDto {

    /**
     * 供給地点特定番号
     */
    suppntSpno?: string;
    /**
     * 再取込処理ステータスコード
     */
    reimpTrnsts?: string;
}

